//@flow 
import React from 'react';
const className = 'c-Summary';

type Props = {
  label?: string,
  value?: string,
  type?: string
};

const SummaryRow = (props: Props) => {
    const { label = '', value = '', type = 'rows'} = props;
    
    return (
        <div className={`${className}__row`}>
            {type === 'rows' && (
                <>
                    <div className={`${className}__label`}>{label}:</div>
                    <div className={`${className}__value`}>{value}</div>
                </>
            )}
            {type === 'list' && (
                <li>{value}</li>
            )}
        </div>
    );
}

export default SummaryRow;